// extracted by mini-css-extract-plugin
export default {"logos":"B-EWe6AVbrpK0+-lkZ2rCA==","logo":"_5BewVm7EhmPPfFj3Hljy2g=="};